var React = require('react');

function CloudLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m604.57 1151a12.66 12.66 0 0 0 1.51 6h124.4a17.73 17.73 0 0 0 .51-4.28 18 18 0 0 0 -23.66-17.1 34.51 34.51 0 0 0 -64.17-.35 18.42 18.42 0 0 0 -19.2 5 12.67 12.67 0 0 0 -19.39 10.73z"}));
}

CloudLeft.defaultProps = {"viewBox":"0 0 1920 2800"};

module.exports = CloudLeft;

CloudLeft.default = CloudLeft;
